import { useParams } from "@tanstack/react-router";
import { Construction } from "lucide-react";
import { EmptyState, PageHeader } from "../components/ui";
import { modules } from "../lib/modules";

export function ModulePlaceholderPage() {
  const { moduleId } = useParams({ strict: false }) as { moduleId: string };
  const item = modules.find((module) => module.href === `/modules/${moduleId}`);
  return (
    <>
      <PageHeader
        eyebrow="Модуль"
        title={item?.title || moduleId}
        description={item?.description}
      />
      <div
        style={{
          background: "var(--bg-surface)",
          border: "1px solid var(--border-subtle)",
          borderRadius: "var(--radius-md)",
        }}
      >
        <EmptyState
          icon={<Construction size={28} />}
          title="Экран переносится"
          description="Функциональный модуль будет подключён к новому интерфейсу после проверки API-контрактов."
        />
      </div>
    </>
  );
}
